export class Category {
    id: number = 0;
    label: string = ''
}